import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoHorizontal from '../../../assets/images/logo_horizontal.png';
import { ReactComponent as ExitIcon } from '../../../assets/svg/Login/exit.svg';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <main className="privacy-policy-page">
      <header className="privacy-policy-header">
        <button type="button" className="privacy-policy-back" onClick={() => navigate(-1)}>
          <ExitIcon className="privacy-policy-back-icon" />
          <span>返回</span>
        </button>
        <img className="privacy-policy-brand-logo" src={logoHorizontal} alt="LINEUP" />
      </header>

      <article className="privacy-policy-document">
        <div className="privacy-policy-title-block">
          <p className="privacy-policy-kicker">用户协议与隐私政策</p>
          <h1>《LINEUP用户与隐私协议》</h1>
          <p>生效日期：2026年8月5日　版本：1.0</p>
        </div>

        <div className="privacy-policy-notice">
          请在正式上线前补充运营主体名称、注册地址、联系邮箱、服务器所在地及适用法律，并由专业律师结合实际业务进行审核。
        </div>

        <section>
          <h2>一、协议范围与接受</h2>
          <p>
            本协议由您与LINEUP的实际运营主体（以下简称“我们”或“LINEUP”）共同订立，适用于您注册、登录和使用LINEUP网站、桌面应用及相关SaaS服务。
            LINEUP面向影视创作者及剧组成员，提供影视项目、剧本分场分景、元素管理、预算、拍摄计划、团队协作、分享及文件导出等功能。
          </p>
          <p>
            当您勾选同意、注册、登录或继续使用服务，即表示您已阅读并同意本协议。若您代表公司、制片机构或剧组使用服务，您确认已获得代表该组织接受本协议的授权。
          </p>
        </section>

        <section>
          <h2>二、账号注册与安全</h2>
          <ul>
            <li>您应提供真实、准确、完整且持续有效的注册资料，并妥善保管账号、密码及登录设备。</li>
            <li>账号原则上仅限注册人或经所属组织授权的人员使用，不得出租、出售、转让或以其他方式供未经授权者使用。</li>
            <li>如发现账号被盗用、数据异常或其他安全事件，请立即联系我们。因您未妥善保管凭证造成的损失，应由您在法律允许的范围内承担。</li>
          </ul>
        </section>

        <section>
          <h2>三、项目内容、知识产权与保密</h2>
          <p>
            您上传、创建或导入的剧本、分场资料、角色与演员资料、剧组名单、场景与地点、预算、拍摄计划、通告相关资料、附件及其他项目内容（统称“用户内容”），其权利仍归您或相应权利人所有。
            您仅授予LINEUP为提供、维护、备份、保障安全及改进您所使用服务所必要的、有限的处理权限。
          </p>
          <ul>
            <li>我们不会因您使用LINEUP而取得用户内容的著作权或项目所有权。</li>
            <li>未经授权，我们不会将您的未公开剧本、拍摄计划或其他项目内容用于公开展示、广告宣传或出售给第三方。</li>
            <li>您应确保有权上传和处理用户内容，并已就其中涉及的演员、剧组成员、联系人或其他个人信息取得必要授权或具备其他合法依据。</li>
            <li>您应依据项目保密要求合理设置成员角色和权限；项目拥有者及管理员应定期审查协作者名单，并及时移除离组或不再需要访问的成员。</li>
          </ul>
        </section>

        <section>
          <h2>四、协作权限与用户责任</h2>
          <p>
            LINEUP可能提供拥有者、管理员、可编辑者、可复制者及仅可见者等角色。具体能力以产品界面当时展示为准。项目拥有者或管理员进行邀请、分享、复制授权及所有权转移时，应确认接收方身份与授权范围。
          </p>
          <p>
            您不得利用LINEUP侵害他人的知识产权、隐私、商业秘密或其他合法权益，不得上传违法内容、恶意代码，或实施干扰服务、绕过权限、未经授权访问或批量抓取数据等行为。
          </p>
        </section>

        <section>
          <h2>五、我们收集的信息</h2>
          <ul>
            <li><strong>账号与组织信息：</strong>用户名、姓名或称呼、手机号、电子邮箱、头像文字、职位、所属组织及账号状态。</li>
            <li><strong>项目与协作信息：</strong>您创建或获授权访问的项目内容、成员关系、角色权限、操作记录和文件版本。</li>
            <li><strong>设备与日志信息：</strong>设备类型、操作系统、浏览器、IP地址、登录时间、错误日志、安全日志及基础使用记录。</li>
            <li><strong>订阅与交易信息：</strong>套餐、有效期、订单状态及必要的支付结果；完整支付卡资料通常由合规支付服务商处理。</li>
            <li><strong>客服信息：</strong>您提交的咨询、反馈、故障信息及与客服的沟通内容。</li>
          </ul>
          <p>我们遵循目的明确、最小必要原则，不主动要求您提交与服务无关的敏感个人信息。</p>
        </section>

        <section>
          <h2>六、信息的使用目的</h2>
          <p>我们可能将上述信息用于：</p>
          <ul>
            <li>创建和管理账号，验证身份，提供项目协作、权限、同步、备份、导出及客户支持；</li>
            <li>保障账号、项目与服务安全，排查故障，防范欺诈、滥用和未经授权访问；</li>
            <li>维护和改进产品性能、兼容性及用户体验，并生成不识别特定个人的统计信息；</li>
            <li>履行合同、处理订阅与账务、发送必要的服务通知，以及遵守法律义务或监管要求。</li>
          </ul>
        </section>

        <section>
          <h2>七、信息共享、委托处理与跨境传输</h2>
          <p>我们不会出售您的个人信息。仅在下列必要情形共享或委托处理信息：</p>
          <ul>
            <li>按照您或项目管理员的指示，向您邀请的协作者展示相应范围的项目资料；</li>
            <li>由云计算、存储、邮件短信、错误监控、支付或客户支持服务商在受约束范围内提供技术服务；</li>
            <li>为履行法定义务、响应有权机关的合法要求，或保护用户、公众及LINEUP的合法权益；</li>
            <li>发生合并、收购、重组或资产转让时，在符合法律要求并采取保护措施的前提下进行必要转移。</li>
          </ul>
          <p>
            如信息需要传输至您所在司法辖区以外，我们将根据适用法律履行告知、同意、评估、合同备案或其他必要程序，并要求接收方采取适当保护措施。
          </p>
        </section>

        <section>
          <h2>八、保存期限与删除</h2>
          <p>
            我们仅在实现处理目的、履行合同及法定义务所必要的期限内保存信息。账号注销或项目删除后，相关数据将在合理期限内删除或匿名化；但备份系统中的副本可能在备份轮换周期结束后清除，法律要求保留或为处理争议所必需的除外。
          </p>
          <p>项目拥有者删除成员权限不等同于删除该成员在其他项目中的账号或合法访问权限。</p>
        </section>

        <section>
          <h2>九、安全保护</h2>
          <p>
            我们将采用与风险相适应的访问控制、身份验证、传输保护、日志审计、备份及员工权限管理措施。但互联网服务无法保证绝对安全，您也应使用强密码、限制共享范围、及时更新软件，并谨慎导出或在本地保存项目文件。
          </p>
          <p>发生可能影响您权益的数据安全事件时，我们将依法采取补救措施，并在适用法律要求的范围内通知受影响用户及主管机关。</p>
        </section>

        <section>
          <h2>十、您的个人信息权利</h2>
          <p>
            根据适用法律，您可以请求查阅、复制、更正、补充或删除个人信息，限制或反对特定处理，撤回基于同意的授权，或申请注销账号。部分项目资料由项目所属组织控制时，我们可能需要将您的请求转交相应组织处理。
          </p>
          <p>为保护账号与项目安全，我们可能在处理请求前核验您的身份。撤回同意不影响撤回前处理活动的合法性。</p>
        </section>

        <section>
          <h2>十一、未成年人</h2>
          <p>
            LINEUP主要面向具有完全民事行为能力的专业用户。未成年人应在监护人及所属剧组的适当指导和授权下使用服务。若项目内容涉及未成年演员或其他未成年人资料，上传者应严格控制收集范围、访问权限和使用目的，并依法取得监护人授权。
          </p>
        </section>

        <section>
          <h2>十二、服务变更、终止与责任限制</h2>
          <p>
            我们可能为维护、安全、升级或不可抗力而暂停部分服务，并会在合理可行时提前通知。您应根据项目重要性及时导出和保留必要副本。对于由第三方服务、网络故障、不可抗力、用户误操作或未经授权使用造成的损失，各方责任依适用法律及双方另行签署的服务合同确定。
          </p>
        </section>

        <section>
          <h2>十三、协议更新</h2>
          <p>
            我们可能因功能、业务或法律变化更新本协议。重大变更将通过页面提示、站内通知或其他合理方式告知，并标明新的生效日期。若变更需要重新取得同意，我们将依法另行征得您的同意。
          </p>
        </section>

        <section>
          <h2>十四、适用法律、争议与联系</h2>
          <p>
            本协议的适用法律和争议解决方式，应以LINEUP正式运营主体所在地、服务地区及双方商业合同中的约定为准。您可通过以下方式咨询本协议、提出个人信息请求或报告安全问题：
          </p>
          <ul>
            <li>运营主体：[请填写完整公司名称]</li>
            <li>联系邮箱：[请填写隐私或客服邮箱]</li>
            <li>注册地址：[请填写注册地址]</li>
          </ul>
        </section>
      </article>
    </main>
  );
};

export default PrivacyPolicy;
